import React, { Component } from 'react';
import notificationIcon from '../assets/header/ic_notification.png';
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import LocationAddon from '../components/LocationAddOn';
import LanguageSwitcher from './LanguageSwitcher';
import { FormattedMessage } from 'react-intl';
import Avatar from './Avatar';
import rewardsIcon from '../assets/header/ic_rewards.png';
import logoIcon from '../assets/logo-icon.png';
import wrpCoin from '../assets/header/WRP_Coin.gif'
import { connect } from "react-redux";

class Navbar extends Component {

  render() {
    return (
      <React.Fragment>
        <div id="mobile-location" className="container" style={{ backgroundColor: '#fff', boxShadow: '0 0 20px 0 rgba(0,0,0,0.25)' }}>
          <div className="row font-proxima-nova align-items-center">
            <div className="col-8 mx-auto d-md-none">
              <LocationAddon style={{ lineHeight: '30px' }} />
            </div>
          </div>
        </div>
        <div className="site-header">
          <div className="container font-proxima-nova ">
            <nav className="navbar navbar-expand-lg row">
              <div className="col-md-1 col-2">
                <Link className="navbar-brand" to="/">
                  <img src={logoIcon} alt="Winds" />
                </Link>
              </div>
              <div className="col-md-3 d-none d-md-block">
                <div>
                  <div style={{ cursor: 'pointer', backgroundColor: '#EFEFF4', borderRadius: '8px' }}>
                    <span className="input-group-text" style={{ border: 'none', borderRadius: '8px' }}>
                      <LocationAddon />
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-8 col-10 ml-auto">
                <ul className="navbar-nav ml-auto flex-row justify-content-between">
                  <li className="d-md-flex nav-item text-center d-none ">
                    <NavLink exact className="nav-link" to="/" activeclassname='is-active' >
                      <span className="">
                        <FormattedMessage
                          id="navbar.explore"
                          defaultMessage="Explore"
                          description="Explore"
                          values={{ what: 'react-intl' }} />
                      </span>
                    </NavLink>
                  </li>
                  <li className="d-md-flex nav-item text-center d-none ">
                    <NavLink exact className="nav-link" to="/orders" activeclassname='is-active'>
                      <span className="">
                        <FormattedMessage
                          id="navbar.orders"
                          defaultMessage="Orders"
                          description="Orders"
                          values={{ what: 'react-intl' }} />
                      </span>
                    </NavLink>
                  </li>
                  <li className="nav-item text-center">
                    <div className="nav-link">
                      <LanguageSwitcher />
                    </div>
                  </li>
                  <li className="nav-item text-center">
                    <NavLink className="nav-link" to="/notifications" activeclassname='is-active' style={{ padding: 0 }}>
                      <img src={notificationIcon} alt="Notifications" />
                    </NavLink>
                  </li>
                  <li className="nav-item text-center">
                    <NavLink className="nav-link" to="/rewards" activeclassname='is-active' >
                      <img src={rewardsIcon} alt="Rewards" />
                      {this.props?.rewards ? <span className="header-rewards">{this.props?.rewards}</span> : <></>}
                    </NavLink>
                  </li>
                  <li className="nav-item text-center">
                    <NavLink style={{ paddingLeft: "0", textDecoration: "none" }} className="nav-link" to="/coupons" activeclassname='is-active' >
                      <div className='wrp-coin'>
                        <span>{this.props?.wrp?.wrp?.confirmed_wrp || 0}</span>
                        <img className='wrp-coin-img' src={wrpCoin} alt="Rewards" />
                      </div>
                    </NavLink>
                  </li>
                  <Avatar />
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  getCurrentUser: state.global,
  profile: state.global.profile,
  wrp: state.wrp,
  rewards: state.home.rewards
});

export default connect(mapStateToProps)(Navbar);